export var HEADER_SIZES = ["one", "two", "three", "four", "five", "six"];
export var HEADER_TYPES_CONTENT_BLOCK = HEADER_SIZES.map(function (headerType) { return "header-".concat(headerType); });
